// extracted by mini-css-extract-plugin
export default {"container":"cV_b","logo":"cV_F","details":"cV_dN","bonus":"cV_dP"};